function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as t } from "./index.es33.js";
import { memo as y } from "react";
import { clsx as m } from "./index.es105.js";
import { Typography as x } from "./index.es35.js";
import "./index.es36.js";
import r from "./index.es684.js";
var N = /*#__PURE__*/y(function (_ref) {
  var _m, _m2;

  var s = _ref.children,
      e = _ref.isToday,
      p = _ref.isDisabled,
      n = _ref.isHighlighted,
      o = _ref.isStartSelected,
      a = _ref.isEndSelected,
      d = _ref.onClick,
      i = _ref.onMouseEnter,
      l = _ref.onMouseLeave,
      c = _ref.onFocus;
  return t.jsx("button", {
    type: "button",
    onMouseEnter: i,
    onMouseLeave: l,
    onClick: d,
    onFocus: c,
    disabled: p,
    className: r.container,
    children: t.jsx("div", {
      className: m(r.wrapper, (_m = {}, _defineProperty(_m, r.startSelected, o), _defineProperty(_m, r.endSelected, a), _defineProperty(_m, r.endAndStartSelected, o && a), _defineProperty(_m, r.highlightedWrapper, n), _m)),
      children: t.jsx(x.Body2, {
        as: "div",
        className: m(r.inner, r.calendarDayItem, (_m2 = {}, _defineProperty(_m2, r.today, e), _defineProperty(_m2, r.notToday, !e), _m2)),
        children: s
      })
    })
  });
});
export { N as Day };